import Notif from '@/generated/classes/Notif';
export default class NotifExtend extends Notif {
  constructor() {
    super();
  }
}
